var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorPage',{attrs:{"code":"400","status":"Bad Request","href":_vm.$urls.SUPPORT_TICKETS,"href-text":"Submit a support ticket","refresh-link":true}})}
var staticRenderFns = []

export { render, staticRenderFns }